<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Ingresos hoy</span>
  
  </mat-toolbar>
  
  <div class="margin-container apearAnimation">
    <!-- <app-tableusr></app-tableusr> -->
    
    <div class="loading-indicator" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>
  
    <mat-form-field appearance="outline" >
      <mat-label>Filtro</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
    </mat-form-field>
  
    <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
      <table mat-table [dataSource]="dataSource">
        <!--       <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td mat-cell *matCellDef="let element">{{ element.id }}</td>
            </ng-container> -->
  
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
        </ng-container>

          <ng-container matColumnDef="disciplina">
            <th mat-header-cell *matHeaderCellDef>Disciplina</th>
            <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
          </ng-container>

          <ng-container matColumnDef="fecha">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let element">{{ element.fecha | date: 'dd-MM-yyyy HH:mm' }}</td>
          </ng-container>
  
        <ng-container matColumnDef="resultado">
          <th mat-header-cell *matHeaderCellDef>Resultado</th>
          <td mat-cell *matCellDef="let element">
            <label *ngIf="element.resultado"> Ingreso </label>
            <label *ngIf="!element.resultado"> No ingreso </label>
            <mat-icon 
            *ngIf="!element.resultado"
            matTooltip="{{getTextoCodigoNoIngreso(element.codigoNoIngreso)}}"
            matTooltipPosition="above" 
            color="warn"
            style="cursor: pointer;"
            > warning </mat-icon>
          </td>
        </ng-container>
  
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
  
      <mat-paginator
        #paginator
        [length]="length"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 100]"
        (page)="getServerData($event)"
      ></mat-paginator>
    </div>
  </div>
  